// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b9aaea0c","455":"f8fff3c8","977":"8fbd20f5"}[chunkId] + ".chunk.js";
};